import styled from 'styled-components';

export const CollapseContainer = styled.div`
  .ant-collapse-content-box {
    padding: 0;
  }
`;
